export default __webpack_public_path__ + "static/media/AutoCrib.a06088fb.png";